import { createSlice } from '@reduxjs/toolkit';

const gnbMenuSlice = createSlice({
  name: 'menu',
  initialState: {
    isSuccess: false,
    menuList: [],
    groupMenuList: [],
  },
  reducers: {
    createGnbMenu: state => {
      state.isSuccess = false;
    },
    createGnbMenuSuccess: (state, { payload }) => {
      state.isSuccess = payload;
    },
    createGnbMenuFail: state => {
      state.isSuccess = false;
    },
    updateGnbMenu: (state, { payload }) => {
      const newData = {
        titleKo: payload.titleKo,
        titleEn: payload.titleEn,
        urlParameter: payload.urlParameter,
        type: payload.type,
        adminCompId: payload.adminCompId,
        menuLabel: payload.menuLabel,
        menuType: payload.menuType,
      };
      if (payload.menuType === 'CONTAINER') {
        const _menuListArray = state.groupMenuList;
        _menuListArray.push(newData);
        state.groupMenuList = _menuListArray;
      } else {
        const _menuListArray = state.menuList;
        _menuListArray.push(newData);
        state.menuList = _menuListArray;
      }
    },
    deleteGnbMenu: () => {},
    deleteGnbMenuSuccess: (state, { payload }) => {
      if (payload.menuType === 'CONTAINER') {
        state.groupMenuList = [];
      } else {
        state.menuList = [];
      }
    },
    deleteGnbMenuFail: () => {},
  },
});

export const {
  createGnbMenu,
  createGnbMenuSuccess,
  createGnbMenuFail,
  updateGnbMenu,
  deleteGnbMenu,
  deleteGnbMenuSuccess,
  deleteGnbMenuFail,
} = gnbMenuSlice.actions;
export default gnbMenuSlice.reducer;
